<template>
  <div class="container">
    <van-row class="type-wrap">
      <van-col span="12" @click="firstTap">
        <span>{{ firstText ? firstText : '请选择' }}</span>
        <van-icon name="play" />
      </van-col>
      <van-col span="12" @click="secondTap">
        <span>{{ secondText ? secondText : '请选择' }}</span>
        <van-icon name="play" />
      </van-col>
    </van-row>
    <van-list
      v-if="listShow"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      offset="10"
      @load="onLoad"
    >
      <list-com v-for="(item, i) in lists" :key="i" :type="1" :item="item"></list-com>
    </van-list>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无数据"
    />
    <!-- 第一类型选择弹窗 -->
    <van-popup v-model="firstPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="firstColumns"
        @cancel="firstPicker = false"
        @confirm="firstConfirm"
      />
    </van-popup>
    <!-- 第二类型选择弹窗 -->
    <van-popup v-model="secondPicker" round position="bottom">
      <van-picker
        show-toolbar
        :columns="secondColumns"
        @cancel="secondPicker = false"
        @confirm="secondConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import listCom from './listCom'
import { category, search } from '@api/servicebus/servicebus'
import { Toast } from 'vant'
export default {
  components: { listCom },
  data() {
    return {
      firstText: '',
      secondText: '',
      firstPicker: false,
      secondPicker: false,
      columns: [], // 二级分类总数据
      firstColumns: [],
      secondArr: [],
      secondColumns: [],
      cid: '', // 产业Id
      subcid: '', // 栏目Id
      loading: true,
      finished: false,
      pageNum: 1,
      pageSize: 15,
      listShow: true,
      lists: []
    }
  },
  mounted() {
    this.getType()
  },
  methods: {
    getType() {
      category({ type: 1 }).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          this.columns = data
          data.forEach(item => {
            this.firstColumns.push(item.name)
          })

          // 大类
          this.firstText = this.firstColumns[0]
          this.cid = this.columns[0].id

          // 小类
          this.secondArr = this.columns[0].children
          this.secondArr.forEach(item => {
            this.secondColumns.push(item.name)
          })
          this.secondText = this.secondColumns[0]
          this.subcid = this.secondArr[0].id

          // 获取列表数据
          this.getList()
        } else {
          Toast(msg)
        }
      })
    },
    getList(num) {
      if (num) {
        this.pageNum = num
        this.lists = []
      }
      const params = {
        type: 1,
        cid: this.cid,
        subcid: this.subcid,
        page: this.pageNum,
        rows: this.pageSize
      }
      search(params).then(res => {
        const { code, data, msg } = res.data
        if (code == '0000') {
          if (data.rows) {
            data.rows.forEach(item => {
              this.lists.push(item)
            })
            this.loading = false
            if (!data.rows || data.rows.length < this.pageSize) {
              this.finished = true
            } else {
              this.finished = false
            }
            if (this.lists.length == 0) {
              this.listShow = false
            } else {
              this.listShow = true
            }
          }
        } else {
          Toast(msg)
        }
      })
    },
    onLoad() {
      this.pageNum++
      this.getList()
    },
    firstTap() {
      this.firstPicker = true
    },
    secondTap() {
      this.secondPicker = true
    },
    firstConfirm(e) {
      this.firstText = e
      // 二级选项联动
      this.columns.forEach(item => {
        if (item.name == e) {
          this.cid = item.id

          // 小类
          this.secondArr = item.children
          this.secondColumns = []
          this.secondArr.forEach(item => {
            this.secondColumns.push(item.name)
          })
          this.secondText = this.secondColumns[0]
          this.subcid = this.secondArr[0].id
        }
      })
      this.getList(1)
      this.firstPicker = false
    },
    secondConfirm(e) {
      this.secondText = e
      this.secondArr.forEach(item => {
        if (item.name == e) {
          this.subcid = item.id
        }
      })
      this.getList(1)
      this.secondPicker = false
    }
  }
}
</script>
<style lang="scss" scoped>
.type-wrap {
  width: 100%;
  background: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #eee;
  z-index: 10;
  .van-col {
    text-align: center;
    line-height: 36px;
    span {
      font-size: 15px;
    }
    .van-icon {
      font-size: 14px;
      color: #ccc;
      transform: rotate(90deg);
      margin-left: 4px;
    }
  }
}
/deep/.custom-image .van-empty__image {
  width: 90px;
  height: 90px;
  margin-top:20%;
}
</style>
